import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  SAVE_EMAIL_REPORT,
  SAVE_LIST_EMAIL_REPORT,
  DELETE_EMAIL_REPORT,
  GET_EMAIL_REPORT,
  GET_EMAIL_BY_PTT,
} from "../../../helpers/url_api_constant";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  FormGroup,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Modal,
  Row,
  Table,
  Input,
} from "reactstrap";

import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { useDispatch } from "react-redux";

function EmailManagement(props) {

  let history = useHistory();
  const dispatch = useDispatch();
  const permission = getPermission();

  const searchObj = { REPORT_NAME: "" };
  const createObj = {
    PID: "", REPORT_NAME: "", EMAIL_CODE: "", EMAIL_TO: "", EMAIL_CC: "",
    //EMAIL_SUBJECT: "", EMAIL_BODY: "",
  };
  const searchEmailObj = { Search_EmployeeCode: "" };
  const modelEmailObj = { PTT_E_MAIL: "" };

  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [dialogAddMail, setDialogAddMail] = useState(false);
  const [showPageEdit, setShowPageEdit] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [userActionType, setUserActionType] = useState("");


  const [searchEmail, setSearchEmail] = useState(searchEmailObj);
  const [modelEmailUserPTT, setModelEmailUserPTT] = useState(modelEmailObj);
  //sort Column//
  const defaultSorted = [
    {
      dataField: "REPORT_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div className="d-sm-flex align-items-center justify-content-center">

        {permission.eEMP && (
          <OverButton
            onClick={() => {
              setReadonly(false);
              onEdit(row);
              setUserActionType("(Edit)");
            }}
            color="info"
            icon="far fa-edit"
            label="Edit"
          />
        )}

      </div>
    );
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "REPORT_NAME",
      text: "Report Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "EMAIL_TO",
      text: "E-mail To",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: false,
      // isDummyField: true,
      // formatter: SumNameAndLastName,
    },
    {
      dataField: "EMAIL_CC",
      text: "E-mail CC",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: false,
    },
    // {
    //   dataField: "EMAIL_SUBJECT",
    //   text: "Subject",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "15%",
    //     fontSize: "12px",
    //   },
    //   sort: false,
    // },
    // {
    //   dataField: "EMAIL_BODY",
    //   text: "Body",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "15%",
    //     fontSize: "12px",
    //   },
    //   sort: false,
    // },
    {
      dataField: "df1",
      text: "Action",
      headerAlign: "center",
      isDummyField: true,
      formatter: ButtonAction,
      // headerAlign: "center",
      // align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    //userEffect คือทำงานคล้ายๆ onInIt หมายถึงว่า พอมีการเรียกเข้า การใช้งานใน Component นี้จะทำอันนี้เป็นอันแรก//
    resetSearch();
    resetModel();
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "email-management-table";
    let scrollY = 156;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);

      if (headerTable) {
        if (window.scrollY >= scrollY) {
          headerTable.classList.add("fixed-header");

          resizeTableHeader();
        } else {
          headerTable.classList.remove("fixed-header");
        }
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };

  }, []);
  //onInit//

  //Function CURL 
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onSearchEmail = () => {
    if (searchEmail.Search_EmployeeCode != "" && searchEmail.Search_EmployeeCode != null) {
      getEmailByUserPTT(searchEmail);
    }
  };

  const onAdd = () => {
    // setOpenPass("password");
    setReadonly(false);
    resetModel();
    // setPageAdd(true);
    setUserActionType("(Add Record)");
    setShowPageEdit(true);
  };

  const onEdit = row => {
    // console.log(row);
    setCreateModel(row);
    // setPageAdd(true);
    setShowPageEdit(true);
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.EMAIL_TO == "" || createModel.EMAIL_TO == null) {
      bResult = false;
    }
    // if (createModel.EMAIL_SUBJECT == "" || createModel.EMAIL_SUBJECT == null) {
    //   bResult = false;
    // }
    // if (createModel.EMAIL_BODY == "" || createModel.EMAIL_BODY == null) {
    //   bResult = false;
    // }

    return bResult;
  };


  const fetchData = async (searchData) => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_EMAIL_REPORT, searchData);
      // console.log(res);
      setModelDeviceList(res.data.emailResportList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const openDialog = () => {
    setDialogAddMail(true);
    setSearchEmail(searchEmailObj);
    setModelEmailUserPTT(modelEmailObj);
  };

  const addToEmailTo = () => {
    setCreateModel({ ...createModel, EMAIL_TO: (createModel.EMAIL_TO == null || createModel.EMAIL_TO == "" ? "" : createModel.EMAIL_TO) + (createModel.EMAIL_TO == null || createModel.EMAIL_TO == "" ? modelEmailUserPTT.PTT_E_MAIL : "," + modelEmailUserPTT.PTT_E_MAIL) });
    setDialogAddMail(false);
  };

  const addToEmailCC = () => {
    setCreateModel({ ...createModel, EMAIL_CC: (createModel.EMAIL_CC == null || createModel.EMAIL_CC == "" ? "" : createModel.EMAIL_CC) + (createModel.EMAIL_CC == null || createModel.EMAIL_CC == "" ? modelEmailUserPTT.PTT_E_MAIL : "," + modelEmailUserPTT.PTT_E_MAIL) });
    setDialogAddMail(false);
  };

  const getEmailByUserPTT = async (data) => {
    // console.log(data)
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_EMAIL_BY_PTT, data);
      // console.log(res);
      if (res.data.personnelInfoModList.length > 0) {
        setModelEmailUserPTT({ PTT_E_MAIL: res.data.personnelInfoModList[0].EmailAddr });
      } else {
        setModelEmailUserPTT({ PTT_E_MAIL: "" })
      }
      // let dataEmail = res.data.personnelInfoModList[0].EmailAddr;
      // if (dataEmail != null && dataEmail != "") {
      // setModelEmailUserPTT({ PTT_E_MAIL: dataEmail });
      // }
      // setModelEmailUserPTT(res.data.personnelInfoModList[0].EmailAddr);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // useEffect(function () {
  //   console.log(modelEmailUserPTT);
  // }, [modelEmailUserPTT]);

  const saveData = async () => {
    if (validateForm()) {
      dispatch(loadingAction.showLoading());
      try {
        let res = await post(SAVE_EMAIL_REPORT, createModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? dispatch(messageAction.showMessage("Save Success.")) : dispatch(messageAction.showMessage("Update Success."));
          // setPageAdd(false);
          setShowPageEdit(false);
          fetchData(searchModel);
        } else {
          dispatch(messageAction.showMessage(res.resultDescription));
        }
      } catch (error) {
        dispatch(messageAction.showMessage(error.message));
      }
      dispatch(loadingAction.hideLoading());
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20"> {props.t("E-mail Management")}</h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            User Management
                          </Link>
                        </li>

                        <li className="breadcrumb-item active">E-mail Management</li>
                      </ol>
                    </div>
                  </div>
                  <hr />

                  {showPageEdit == true && (
                    <>
                      <CardBody>
                        <AvForm className="needs-validation">
                          <Row>
                            <FormGroup className="row mb-3 d-flex align-items-center justify-content-center">
                              <Label
                                className="col-sm-1 col-form-label text-center"
                              >
                                {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                                Report Name
                              </Label>
                              <Col sm={5} className="align-items-center justify-content-start">
                                <Input
                                  // disabled={readonly}
                                  // name="ALIAS_NAME"
                                  type="text"
                                  // errorMessage="Enter Shipper Name"
                                  className="form-control basicborder"
                                  // validate={{ required: { value: true } }}
                                  disabled
                                  onChange={e =>
                                    setCreateModel({
                                      ...createModel,
                                      REPORT_NAME: e.target.value,
                                    })
                                  }
                                  value={createModel.REPORT_NAME}
                                />
                              </Col>
                              <Col sm={1}>

                              </Col>
                            </FormGroup>
                          </Row>
                          <Row>
                            <FormGroup className="row mb-3 d-flex align-items-center justify-content-center">
                              <Label
                                className="col-sm-1 col-form-label text-center"
                              >
                                <span style={{ color: "#FF0E03" }}>* </span>
                                E-mail To
                              </Label>
                              <Col sm={5}>
                                <AvField
                                  // disabled={readonly}
                                  name="EMAIL_TO"
                                  type="textarea"
                                  style={{ border: "solid 1px #FFFFFF" }}
                                  errorMessage="Enter E-mail To"
                                  className="form-control basicborder"
                                  validate={{ required: { value: true } }}
                                  // disabled
                                  onChange={e =>
                                    setCreateModel({
                                      ...createModel,
                                      EMAIL_TO: e.target.value,
                                    })
                                  }
                                  value={createModel.EMAIL_TO}
                                />
                              </Col>
                              <Col sm={1}>
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    openDialog();
                                  }}
                                //   saveData()
                                // }
                                >
                                  <i className="fas fa-plus fa-lg"></i>
                                </button>
                              </Col>
                            </FormGroup>
                          </Row>

                          <Row>
                            <FormGroup className="row mb-2 d-flex align-items-center justify-content-center">
                              <Label
                                className="col-sm-1 col-form-label text-center"
                              >
                                {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                                E-mail CC
                              </Label>
                              <Col sm={5}>
                                <Input
                                  type="textarea"
                                  style={{ border: "solid 1px #FFFFFF" }}
                                  className="form-control"
                                  onChange={e =>
                                    setCreateModel({
                                      ...createModel,
                                      EMAIL_CC: e.target.value,
                                    })
                                  }
                                  value={createModel.EMAIL_CC}
                                />
                              </Col>
                              <Col sm={1}>
                                {/* <button
                                  type="submit"
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {

                                  }}
                                //   saveData()
                                // }
                                >
                                  <i className="fas fa-plus fa-lg"></i>
                                </button> */}
                              </Col>
                            </FormGroup>
                          </Row>

                          <div className="text-center mt-2">
                            {!readonly &&
                              <button
                                type="submit"
                                className="btn btn-success me-2"
                                onClick={() => saveData()}
                              >
                                <i className="far fa-save"></i> Save
                              </button>
                            }
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => setShowPageEdit(false)}
                            >
                              <i className="fas fa-times"></i> Close
                            </button>
                          </div>
                        </AvForm>
                      </CardBody>
                    </>
                  )}

                  {showPageEdit == false && (
                    <>
                      <Row>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <div className="search-box">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  // style={{backgroundColor:"#FFFFFF"}}
                                  className="form-control rounded-2 basicborder"
                                  placeholder={props.t("Search Report Name")}
                                  onChange={(e) =>
                                    setSearchModel({
                                      ...searchModel,
                                      REPORT_NAME: e.target.value
                                    })
                                  }
                                  value={searchModel.REPORT_NAME}
                                />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </FormGroup>
                        </Col>

                        <Col sm="8">
                          <div className="d-grid gap-2 d-md-block">
                            <Button color="info" className="mt-0"
                              onClick={() => onSearch()}>
                              <i className="fas fa-search"></i>
                              &nbsp; Search
                            </Button>

                            <Button color="warning" className="mt-0 ms-2"
                              onClick={() => resetSearch()}>
                              <i className="fas fa-redo-alt"></i>
                              &nbsp; Reset
                            </Button>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm="12">
                          <div>
                            {/* แบบเดิมใน div ใช้ ClassName นี้ className="table-responsive" */}
                            <BootstrapTable
                              id="email-management-table"
                              keyField="PID"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalEmail */}
      <Modal size="lg" isOpen={dialogAddMail}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Search E-mail
          </h5>
        </div>
        <div className="modal-body">

          <CardBody>
            <AvForm className="needs-validation">

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Employee Code
                  </Label>
                  <Col sm={7}>
                    <AvField
                      // disabled={readonly}
                      name="Search_EmployeeCode"
                      type="number"
                      // maxLength={6}
                      errorMessage="Enter Employee Code"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      // disabled
                      onChange={e =>
                        setSearchEmail({
                          ...searchEmail,
                          Search_EmployeeCode: e.target.value,
                        })
                      }
                      value={searchEmail.Search_EmployeeCode}
                    />
                  </Col>
                  <Col sm={1}>
                    <button
                      type="submit"
                      className="btn btn-info btn-sm mt-1"
                      onClick={() => {
                        onSearchEmail();
                      }}
                    >
                      <i className="fas fa-search fa-lg"></i>
                    </button>
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                    E-mail
                  </Label>
                  <Col sm={7}>
                    <Input
                      type="text"
                      style={{ border: "solid 1px #FFFFFF" }}
                      className="form-control"
                      disabled
                      onChange={e =>
                        setModelEmailUserPTT({
                          ...modelEmailUserPTT,
                          PTT_E_MAIL: e.target.value,
                        })
                      }
                      value={modelEmailUserPTT.PTT_E_MAIL}
                    />
                  </Col>
                  <Col sm={1}>

                  </Col>
                </FormGroup>
              </Row>

              <div className="text-center mt-2">
                {modelEmailUserPTT.PTT_E_MAIL != "" &&
                  <>
                    <button
                      type="submit"
                      className="btn btn-primary me-2"
                      onClick={() => {
                        addToEmailTo()
                      }}
                    >
                      <i className="fas fa-plus fa-lg"></i> Add to E-mail To
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success me-2"
                      onClick={() => {
                        addToEmailCC()
                      }}
                    >
                      <i className="fas fa-plus fa-lg"></i> Add to E-mail CC
                    </button>
                  </>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setDialogAddMail(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
          {/* {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )} */}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/* end: ModalEmail */}

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            E-mail Management {userActionType}
          </h5>
        </div>
        <div className="modal-body">

          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                    Report Name
                  </Label>
                  <Col sm={8}>
                    <Input
                      // disabled={readonly}
                      // name="ALIAS_NAME"
                      type="text"
                      // errorMessage="Enter Shipper Name"
                      className="form-control basicborder"
                      // validate={{ required: { value: true } }}
                      disabled
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          REPORT_NAME: e.target.value,
                        })
                      }
                      value={createModel.REPORT_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    <span style={{ color: "#FF0E03" }}>* </span>
                    E-mail To
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // disabled={readonly}
                      name="EMAIL_TO"
                      type="text"
                      errorMessage="Enter E-mail To"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      // disabled
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          EMAIL_TO: e.target.value,
                        })
                      }
                      value={createModel.EMAIL_TO}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                    E-mail CC
                  </Label>
                  <Col sm={8}>
                    <Input
                      type="textarea"
                      style={{ border: "solid 1px #FFFFFF" }}
                      className="form-control"
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          EMAIL_CC: e.target.value,
                        })
                      }
                      value={createModel.EMAIL_CC}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/* end: PageAdd */}

    </React.Fragment >
  );
}

EmailManagement.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ EmailManagement }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EmailManagement));

